import { useLocation, useNavigate } from 'react-router-dom';
import { useState, useEffect, useCallback, useMemo } from 'react';
import {
    FormContainer,
    DataForm,
    PageContainerActionParamType,
    Loader,
    DataFormFieldChangeParamType,
    SaveDataParamType,
    useStateContext,
} from "@vegi.toenlioe/novitate-react-components";
import HargaBarang from '../../../models/HargaBarang';
import { validate as uuidValidate } from "uuid";
import { MenuItems } from '../../../utils/Menu';

const groupName: string = "Servis";
const subgroupName: string = "Master";
const code: string = "SERVICE-HARGA-BRG";
const title: string = "Harga Barang";
const endpoint = "harga_brg";

function Form() {
	const location = useLocation();
    const {authState, setAuthState, apiCaller} = useStateContext();
    const [loading, setLoading] = useState(false);
	const [formData, setFormData] = useState<HargaBarang>({ kode: '', harga_brg: 0 });
    const navigate = useNavigate();
    
    const isViewMode: boolean = useMemo(() => location?.state?.isViewMode ?? false, [location]);

	useEffect(() => {
		if (!location?.state?.ucode)
            return;

        setLoading(true);
		apiCaller?.get(`${endpoint}/id?ucode=${location.state.ucode}`)
            .then((response) => setFormData({...response.data?.data}))
            .catch((error) => console.error({error}))
            .finally(() => setLoading(false))
        ;
	}, [location.state]);

    const onChanged = useCallback((valueObj: any) => {
        const {data, fieldName, value, isObject, keyFieldName, name} = valueObj;

        if (isObject && name && keyFieldName)
		{
            setFormData({
                ...formData,
                [fieldName]: value ? value[keyFieldName] : null,
                [name]: value,
            });
			return;
		}

		setFormData({
            ...data,
            [fieldName]: value,
        });
    }, [formData]);

    const onValidate = useCallback((data: HargaBarang | undefined) => {
        if (!data?.harga_brg)
            return false;

        if (!data?.kode)
            return false;

        return true;
    }, []);

    const onClose = useCallback((pathObject: PageContainerActionParamType | null | undefined) => {
        navigate(`${pathObject?.mainPath}${pathObject?.path}`);
    }, [navigate]);

    const onSave = useCallback((param: SaveDataParamType<HargaBarang> | undefined) => {
        if (!param?.data || !apiCaller)
            return;

        setLoading(true);

        const apiCallerObj = param.data.ucode ? apiCaller.put(endpoint, JSON.stringify(param.data)) : apiCaller.post(endpoint, JSON.stringify(param.data));

        apiCallerObj
            .then(() => {
                setLoading(false);

                if (param.callback)
                    param.callback();
            })
            .catch((error) => {
                console.error({error});
                setLoading(false);
            })
        ;
    }, [apiCaller]);

    return (
		<>
        {
            loading && <Loader />
        }
            <FormContainer
                groupName={groupName}
                subgroupName={subgroupName}
                code={code}
                title={title}
                editMode={formData?.ucode !== null && uuidValidate(formData?.ucode)}
                isViewMode={isViewMode}
            >
                <DataForm<HargaBarang>
                    menuItems={MenuItems}
                    groupName={groupName}
                    subgroupName={subgroupName}
                    code={code}
                    title={title}
                    data={formData}
					isViewMode={isViewMode}
                    fields={[
                        {
                            name: "kode",
                            title: "Kode Harga Barang",
                            inputType: "text",
                            dataType: (typeof formData.kode),
                            isReadonly: false,
                            isRequired: formData?.ucode ? true : false,
                            onChanged: (valueObj: DataFormFieldChangeParamType<HargaBarang>) => onChanged(valueObj),
                        },
                        {
                            name: "harga barang",
                            title: "Harga barang",
                            inputType: "text",
                            dataType: (typeof formData.harga_brg),
                            isReadonly: false,
                            isRequired: true,
                            onChanged: (valueObj: DataFormFieldChangeParamType<HargaBarang>) => onChanged(valueObj),
                        }
                    ]}
                    onValidate={onValidate}
                    onClose={(pathObject) => onClose(pathObject)}
                    onSave={(data) => onSave(data)}
                />
            </FormContainer>		
		</>
    );
};

export default Form;
